import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=d5a04e5c&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./EmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=d5a04e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a04e5c",
  null
  
)

export default component.exports